import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Grid, Typography } from "@mui/material";
import confirmTrip from "assets/images/confirmTrip.svg";

function PaymentFailed() {
  const navigate = useNavigate()

  const onHome = () => {
    sessionStorage.clear()
    navigate('/home')
  }

  return (
    <div>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className="textAlign marginTop45 myRideMain h100"
      >
        <Grid item>
          <img src={confirmTrip} alt="confirmTrip" />
        </Grid>
        <Grid item>
          <Typography className="font28 colorRed fontMedium marginTop15">
            Payment Failed
          </Typography>
          <Typography className="font20 fontMedium">
            Try Again
          </Typography>
          <Button onClick={() => onHome()} className="primaryBtn">Back To Home</Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default PaymentFailed;
